import { GridModel } from "common/models/utility-models/list-utility.model";
import { AssignmentReportsModel } from "./assignment-report.data-model";

export class AssignmentReportsGridModel extends AssignmentReportsModel { }

export class AssignmentReportsListingModel extends GridModel<AssignmentReportsModel> {
    filterData: any;
}